import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';

const News = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#433ED1', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    In News
                </Typography>
            </Box>

            {/* news images */}
            <Box sx={{ display: 'flex', width: { sm: '66%', md: '63%', lg: '65%', xl: '55%' }, mx: 'auto', justifyContent: 'space-between', pt: '10px', pb: { xs: '20px', md: '28px' } }}>
                <Box className="image-hover" sx={{ width: { xs: '63px', sm: '85px', md: '115px', lg: '154px' }, mx: { xs: 'auto', sm: '0' }, px: { xs: '46px', sm: '62px', md: '70px', lg: '102px' }, py: { xs: '10px', sm: '14px', md: '16px', lg: '20px' }, border: '0.413423px solid #F0F0FF', borderRadius: '6px' }}>
                    <CardMedia
                        component="img"
                        image="https://i.ibb.co/nRk5Qqh/news1.png"
                        alt="logo"
                    />
                </Box>

                <Box className="image-hover" sx={{ width: { xs: '98px', sm: '140px', md: '165px', lg: '238px' }, mx: { xs: 'auto', sm: '0' }, px: { xs: '29px', sm: '35px', md: '45px', lg: '60px' }, py: { xs: '10px', sm: '14px', md: '16px', lg: '20px' }, border: '0.413423px solid #F0F0FF', borderRadius: '6px' }}>
                    <CardMedia
                        component="img"
                        image="https://i.ibb.co/4MNt9r7/news2.png"
                        alt="logo"
                    />
                </Box>
            </Box>
        </div>
    );
};

export default News;